module.exports = __webpack_public_path__ + "img/in_1@4x.8603cae0.png";